import { render, staticRenderFns } from "./ProfitItemsPopup.vue?vue&type=template&id=72d93916"
import script from "./ProfitItemsPopup.vue?vue&type=script&lang=js"
export * from "./ProfitItemsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports